/* eslint-disable max-len */
import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import moment from 'moment';
import {reverse} from 'core/urls';
import createRTIKitsOrderMutation from 'graphql/mutations/orders/create-rti-multiplier-kits-order.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import {getDefaultAddress} from 'core/utils';
import AddressGrid from 'components/address-grid';
import {Form, Field, Input, Textarea, DateInput, TimeInput, LocalitySelect, Toggle} from 'components/forms';
import {gt} from 'components/forms/form/validators';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createRTIKitsOrderMutation, {loadAddresses: true})
@autobind
export default class RTIMultiplierKitsCreate extends Component {
    requireInvitationFields(value, allValues) {
        return allValues.makeInvitations;
    }

    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='RTI' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar refundType='rti' userType='multiplier' links={['refund', 'kits']} />
                    <div className={styles.formContainer}>
                        <Form
                            fields={this.props.populateInitial([
                                {key: 'attendees', validators: [gt(0)]},
                                {key: 'notes', required: false},
                                {key: 'date', required: this.requireInvitationFields},
                                {key: 'time', required: this.requireInvitationFields},
                                {key: 'rsvpEmail', required: this.requireInvitationFields, validators: ['email']},
                                {key: 'rsvpPhone', required: this.requireInvitationFields},
                                {key: 'locationName', required: this.requireInvitationFields},
                                {key: 'locationLocality', required: this.requireInvitationFields},
                                {key: 'locationAddress', required: this.requireInvitationFields},
                                {key: 'topics', required: this.requireInvitationFields},
                                {key: 'extraInfo', required: this.requireInvitationFields},
                                {key: 'makeInvitations', required: false, initial: false},
                                {
                                    key: 'address',
                                    initial: getDefaultAddress(this.props.addressesData),
                                },
                            ])}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid, values}) => (
                                <Fragment>
                                    <div className={styles.title}>Solicitud de Invitaciones y Kits</div>
                                    <Field label='Cantidad de invitados'>
                                        <Input type='number' {...getFieldProps('attendees')} />
                                        {renderErrors('attendees')}
                                    </Field>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                    <Field>
                                        <Toggle
                                            type='checkbox'
                                            label='Incluir armado de invitaciones'
                                            {...getFieldProps('makeInvitations')}
                                        />
                                        {renderErrors('makeInvitations')}
                                    </Field>
                                    {values.makeInvitations && (
                                        <Fragment>
                                            <Field label='Fecha'>
                                                <DateInput min={moment().format('YYYY-MM-DD')} {...getFieldProps('date')} />
                                                {renderErrors('date')}
                                            </Field>
                                            <Field label='Hora'>
                                                <TimeInput {...getFieldProps('time')} />
                                                {renderErrors('time')}
                                            </Field>
                                            <Field label='Email de confirmación' helptext='Este email aparece en la invitación para que los invitados confirmen su asistencia.'>
                                                <Input type='email' {...getFieldProps('rsvpEmail')} />
                                                {renderErrors('rsvpEmail')}
                                            </Field>
                                            <Field label='Teléfono de confirmación' helptext='Este teléfono aparece en la invitación para que los invitados confirmen su asistencia.'>
                                                <Input type='text' {...getFieldProps('rsvpPhone')} />
                                                {renderErrors('rsvpPhone')}
                                            </Field>
                                            <Field label='Nombre del establecimiento' helptext='Nombre del establecimiento donde se realiza el campo líder.'>
                                                <Input type='text' {...getFieldProps('locationName')} />
                                                {renderErrors('locationName')}
                                            </Field>
                                            <Field label='Localidad del establecimiento'>
                                                <LocalitySelect {...this.props.getLocalitySelectProps(getFieldProps('locationLocality'))} />
                                                {renderErrors('locationLocality')}
                                            </Field>
                                            <Field label='Dirección del establecimiento' helptext='Dirección del establecimiento donde se realiza el campo líder. pueden incluir coordenadas GPS.'>
                                                <Input type='text' {...getFieldProps('locationAddress')} />
                                                {renderErrors('locationAddress')}
                                            </Field>
                                            <Field label='Temas y disertantes'>
                                                <Textarea {...getFieldProps('topics')} />
                                                {renderErrors('topics')}
                                            </Field>
                                            <Field label='Información adicional para incluir en la invitación'>
                                                <Textarea {...getFieldProps('extraInfo')} />
                                                {renderErrors('extraInfo')}
                                            </Field>
                                        </Fragment>
                                    )}
                                    <Field label='Dirección de envío de los kits'>
                                        <AddressGrid
                                            addresses={this.props.addressesData.addresses}
                                            returnUrl={reverse('clMultiplierKitsCreate')}
                                            returnData={values}
                                            {...getFieldProps('address')}
                                        />
                                        {renderErrors('address')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                        <p className={styles.reminder}>Recuerde seleccionar la organización correcta antes de enviar el pedido</p>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/rti-multiplier/kits/index.js